import { intersection, size } from "lodash";
import { Platform } from "@linkfluence/models/platform";
import { getAllPlatforms } from "@linkfluence/models/platform";
import { useCurrentProject } from "./useCurrentProject";

export function useCurrentProjectPlatforms(platforms?: Platform[]) {
  const projectPlatforms = intersection(
    getAllPlatforms(),
    useCurrentProject()?.platforms || []
  );
  return size(platforms)
    ? intersection(platforms, projectPlatforms)
    : projectPlatforms;
}
